var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M.7 0h60v10H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 10h60v10H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be0027",
    d: "M.7 20h60v10H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b5aa3",
    d: "M.7 30h60v10H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#239e46",
    d: "M.7 0v40l29.8-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 11a9 9 0 0 0-9.7 9.1 9 9 0 0 0 8.8 8.6c-2.3-1-5-4.1-5.1-8.6 0-4 2.3-7.6 6-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.9 15.4-1-.7-1.1.3.4-1.1-.7-1h1.2l.7-.9.3 1.2 1.1.3-1 .7zm0 4-1-.7-1.1.4.4-1.1-.7-1h1.2l.7-1 .3 1.2 1.1.4-1 .7zm0 4.2-1-.8-1.1.4.4-1.1-.7-1h1.2l.7-.9.3 1.1 1.1.4-1 .7zm0 4.1-1-.7-1.2.3.5-1-.7-1h1.2l.7-1 .3 1.2 1.1.4-1 .6z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.553d079a326f97de5a39a604bb2157d0.svg";
export { ForwardRef as ReactComponent };